import { Profile } from "../domain/Profile";
import { ProfileRepository } from "../domain/ProfileRepository";

export class ProfileAllCommands{
    screen_data: Profile;
    profile_repo: ProfileRepository;
    constructor(screen_data: Profile, profile_repo: ProfileRepository){
        this.screen_data = screen_data
        this.profile_repo = profile_repo
    }

    async run(){
        await this.userHasSomeFacturaEService()
    }

    async userHasSomeFacturaEService(){
        const args = {}
        const result = await this.profile_repo.userHasSomeFacturaEService(args)
        this.screen_data.user_has_some_facturae_service = result
    }
}